import React from 'react'
import { TextInput } from 'react-admin'
import {
  MultilangParseFunction,
  MultilangWriteFunction,
} from 'services/utils/multilangParseWrite'
import { RAInputProps, WithForceDisabled } from 'types/common'
import LocalizedInput from './LocalizedInput'

type LocalizedTextInputProps = RAInputProps &
  WithForceDisabled & {
    writeFunction?: MultilangWriteFunction
    parseFunction?: MultilangParseFunction
  }

const LocalizedInputText: React.FC<LocalizedTextInputProps> = ({
  forceDisabled,
  ...rest
}) => (
  <LocalizedInput {...rest}>
    <TextInput {...rest} disabled={forceDisabled} />
  </LocalizedInput>
)

export default LocalizedInputText
